import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/manga";

export default function HotList() {
  const hot = [...mangaList].sort((a, b) => Number(b.rating) - Number(a.rating)).slice(0, 6);
  const top1 = hot[0];

  return (
    <section id="hot" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1400px] px-4">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-fire-fill"></i>
              热门榜单
            </span>
            <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">最近大家都在嗑</h2>
            <p className="mt-2 text-[15px] text-foreground-600">
              追更人数最多的恋爱漫画，脸红情节与恋爱拉扯高能集中营。
            </p>
          </div>
          <Link
            to="/category/chuntian"
            className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            查看全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {/* 榜首推荐 */}
          <Link
            to={`/detail/${top1.id}`}
            className="group relative hidden overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 lg:block"
          >
            <div className="relative aspect-[3/4] w-full overflow-hidden">
              <img
                src={top1.cover}
                alt={`${top1.title} 热门榜首恋爱漫画`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent"></div>
              <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
                NO.1 榜首
              </span>
              <div className="absolute inset-x-0 bottom-0 p-4 text-background-50">
                <span className="text-xs text-accent-300">{top1.categoryName} · {top1.status}</span>
                <h3 className="mt-1 font-display text-2xl">{top1.title}</h3>
                <p className="mt-1 line-clamp-2 text-sm text-background-100/90">{top1.heroLine}</p>
                <div className="mt-3 flex items-center gap-4 text-xs text-background-200">
                  <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{top1.viewers} 人气</span>
                  <span className="flex items-center gap-1"><i className="ri-star-fill text-accent-400"></i>{top1.rating}</span>
                </div>
              </div>
            </div>
          </Link>

          {/* 排名列表 */}
          <div className="flex flex-col gap-3 lg:col-span-2">
            {hot.map((manga, idx) => (
              <Link
                key={manga.id}
                to={`/detail/${manga.id}`}
                className="group flex items-center gap-4 rounded-2xl border border-background-200/70 bg-background-50 p-3 transition-colors hover:border-primary-200"
              >
                <span
                  className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl font-display text-lg ${
                    idx === 0
                      ? "bg-accent-500 text-background-50"
                      : idx === 1
                      ? "bg-secondary-400 text-background-50"
                      : "bg-primary-100 text-primary-600"
                  }`}
                >
                  {idx + 1}
                </span>
                <img
                  src={manga.cover}
                  alt={`${manga.title} 热门作品`}
                  className="h-16 w-12 shrink-0 rounded-lg object-cover"
                />
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="truncate font-bold text-foreground-950 group-hover:text-primary-600">{manga.title}</h3>
                    <span className="shrink-0 rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                      {manga.categoryName}
                    </span>
                  </div>
                  <p className="mt-1 truncate text-xs text-foreground-500">{manga.heroLine}</p>
                  <div className="mt-1.5 flex items-center gap-2">
                    <span className="h-1.5 w-24 overflow-hidden rounded-full bg-background-200">
                      <span
                        className="block h-full rounded-full bg-primary-500"
                        style={{ width: `${manga.intensity}%` }}
                      ></span>
                    </span>
                    <span className="text-[11px] text-foreground-500">心动指数 {manga.intensity}</span>
                  </div>
                </div>
                <div className="hidden shrink-0 text-right sm:block">
                  <p className="flex items-center justify-end gap-1 text-sm font-bold text-foreground-950">
                    <i className="ri-star-fill text-accent-500"></i>
                    {manga.rating}
                  </p>
                  <p className="mt-1 text-[11px] text-foreground-500">{manga.viewers} 追更</p>
                  <p className="mt-1 text-[11px] text-primary-600">{manga.latestChapter}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}